import { render, staticRenderFns } from "./AddServiceItem.vue?vue&type=template&id=27366080&"
import script from "./AddServiceItem.vue?vue&type=script&lang=js&"
export * from "./AddServiceItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports